/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const AngleUpLightIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M7.34857 4.61445L12.1054 9.49882C12.2982 9.6937 12.2982 10.0088 12.1054 10.2037L11.8143 10.4981C11.6216 10.693 11.3099 10.693 11.1172 10.4981L7 6.2564L2.88284 10.4939C2.6901 10.6888 2.37844 10.6888 2.18571 10.4939L1.89455 10.1996C1.70182 10.0047 1.70182 9.68955 1.89455 9.49468L6.65144 4.61031C6.84417 4.41958 7.15583 4.41958 7.34857 4.61445Z"
        fill={color}
      />
    </svg>
  );
};
